import { Button } from "../../../../components/ui/common/button";

interface SupplierListPaginationProps {
  totalCount: number;
  pageNumber: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

/**
 * Tailwind pagination footer, copied from `ProductListPagination`: a count
 * label on the left, Previous/Next `Button`s with a "Page X of Y" label on
 * the right. Same simplification the Product/Ingredient redesigns already
 * made — replaces the legacy Semantic UI `PaginationView`
 * (src/components/pagination/Pagination.tsx), dropping its page-size
 * dropdown and numbered pager in favor of this simpler, prototype-matching
 * pattern. Server-side pagination itself (page number, total pages) is
 * otherwise untouched.
 */
const SupplierListPagination = ({
  totalCount,
  pageNumber,
  totalPages,
  onPageChange
}: SupplierListPaginationProps) => (
  <div className="tw-mt-3 tw-flex tw-items-center tw-justify-between">
    <p className="tw-text-xs tw-text-muted-foreground">
      {totalCount} supplier{totalCount !== 1 ? "s" : ""} found
    </p>
    {totalPages > 1 ? (
      <div className="tw-flex tw-items-center tw-gap-2">
        <Button
          variant="outline"
          size="sm"
          disabled={pageNumber <= 1}
          onClick={() => onPageChange(pageNumber - 1)}
        >
          Previous
        </Button>
        <span className="tw-text-sm tw-text-muted-foreground">
          Page {pageNumber} of {totalPages}
        </span>
        <Button
          variant="outline"
          size="sm"
          disabled={pageNumber >= totalPages}
          onClick={() => onPageChange(pageNumber + 1)}
        >
          Next
        </Button>
      </div>
    ) : null}
  </div>
);

export default SupplierListPagination;
